import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue'),
    meta: { title: '医学科教信息平台' }
  },
  {
    path: '/index',
    name: 'homeIndex',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue'),
    meta: { title: '医学科教信息平台' }

  },
  // {
  //   path: '/',
  //   name: 'login',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/login.vue')
  // },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/login.vue'),
    meta: { title: '医学科教信息平台-登录' }
  },
  // {
  //   path: '/perio',
  //   name: 'perio',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/perio.vue')
  // },
  // {
  //   path: '/perioDetails',
  //   name: 'perioDetails',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/perioDetails.vue')
  // },
  // {
  //   path: '/searchIndex',
  //   name: 'searchIndex',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/searchIndex.vue'),
  //   // beforeEnter(to, from, next) {//进入组件前执行。
  //   //     console.log(to);
  //   //     console.log(from);
  //   //     // next('/');//如果加了这句话，就永远进入不了当前组件，因为，无条件跳转到/addGoods
  //   //   },
  // },
  // {
  //   path: '/seniorSearch',
  //   name: 'seniorSearch',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/seniorSearch.vue')
  // },
  {
    path: '/details',
    name: 'details',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/details.vue')
  },
  {
    path: '/haveNo',
    name: 'haveNo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/haveNo.vue')
  },
  {
    path: '/404',
    name: '404',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/404.vue')
  },
  {
    path: '/biology',
    name: 'biology',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/biology.vue'),
    meta: { title: '医学科教信息平台-专题' }
  },
  {
    path: '/track',
    name: 'track',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/track.vue'),
    meta: { title: '医学科教信息平台-我的跟踪' }
  },
  {
    path: '/search',
    name: 'search',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/search.vue'),
    meta: { title: '医学科教信息平台-搜索' }
  },
  {
    path: '/articleDetails',
    name: 'articleDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/articleDetails.vue'),
    meta: { title: '医学科教信息平台-文章详情' }
  },
  {
    path: '/user',
    name: 'user',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    redirect: '/user/collection',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/index.vue'),
    children: [
      {
        path: '/user/collection',
        name: 'userCollection',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/user/collection.vue'),
        meta: { title: '医学科教信息平台-我的收藏' }

      },
      {
        path: '/user/mymsg',
        name: 'userMyMessage',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/user/myMessage.vue'),
        meta: { title: '医学科教信息平台-我的消息' }

      },
      {
        path: '/user/basicmsg',
        name: 'userBasicMessage',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/user/basicMessage.vue'),
        meta: { title: '医学科教信息平台-基本信息' }
      },
      {
        path: '/user/queueList',
        name: 'userQueueList',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/user/queueList.vue'),
        meta: { title: '医学科教信息平台-栏目排序' }
      },
      {
        path: '/user/keywordConfig',
        name: 'userKeywordConfig',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/user/keywordConfig.vue'),
        meta: { title: '医学科教信息平台-关键字配置' }
      },
      {
        path: '/user/articleConfig',
        name: 'userArticleConfig',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/user/articleConfig.vue'),
        meta: { title: '医学科教信息平台-系统推送' }
      },
      {
        path: '/user/medicalFrontierInfo',
        name: 'userMedicalFrontierInfo',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/user/medicalFrontierInfo.vue'),
        meta: { title: '医学科教信息平台-医学前沿信息' }
      },
      {
        path: '/user/rotationNewsSetting',
        name: 'rotationNewsSetting',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/user/rotationNewsSetting.vue'),
        meta: { title: '医学科教信息平台-轮播图片维护' }
      },
      {
        path: '/user/platformStatistics',
        name: 'rotationNewsSplatformStatisticstting',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/user/platformStatistics.vue'),
        meta: { title: '医学科教信息平台-平台统计' }
      },
    ]
  },
  // {
  //   path: '/manage',
  //   name: 'manage',
  //   redirect: '/manage/articleConfig',
  //   component: () => import('../views/manage/index.vue'),
  //   children: [
  //     {
  //       path: '/manage/articleConfig',
  //       name: 'articleConfig',
  //       component: () => import('../views/manage/articleManage/articleConfig.vue'),
  //     },
  //     {
  //       path: '/manage/infoConfig',
  //       name: 'infoConfig',
  //       component: () => import('../views/manage/infoConfig.vue'),
  //     },
  //     {
  //       path: '/manage/carouselConfig',
  //       name: 'carouselConfig',
  //       component: () => import('../views/manage/carouselConfig.vue'),
  //     },
  //     {
  //       path: '/manage/columnConfig',
  //       name: 'columnConfig',
  //       component: () => import('../views/manage/articleManage/columnConfig.vue'),
  //     },
  //     {
  //       path: '/manage/keywordConfig',
  //       name: 'keywordConfig',
  //       component: () => import('../views/manage/articleManage/keywordConfig.vue'),
  //     },
  //     {
  //       path: '/manage/publish',
  //       name: 'publish',
  //       component: () => import('../views/manage/publish.vue'),
  //     },
  //     {
  //       path: '/manage/sensitiveWordConfig',
  //       name: 'sensitiveWordConfig',
  //       component: () => import('../views/manage/articleManage/sensitiveWordConfig.vue'),
  //     },
  //     {
  //       path: '/manage/accountManage',
  //       name: 'accountManage',
  //       component: () => import('../views/manage/accountManage/index.vue'),
  //     },
  //     {
  //       path: '/manage/userManage',
  //       name: 'userManage',
  //       component: () => import('../views/manage/userManage/index.vue'),
  //     },
  //     {
  //       path: '/manage/addArticle',
  //       name: 'addArticle',
  //       component: () => import('../views/manage/articleManage/addArticle.vue'),
  //     },
  //     {
  //       path: '/manage/updateArticle',
  //       name: 'updateArticle',
  //       component: () => import('../views/manage/articleManage/updateArticle.vue'),
  //     },
  //     {
  //       path: '/manage/publicSentimentCategory',
  //       name: 'publicSentimentCategory',
  //       component: () => import('../views/manage/publicSentimentManage/publicSentimentCategory.vue'),
  //     },
  //     {
  //       path: '/manage/publicSentimentConfig',
  //       name: 'publicSentimentConfig',
  //       component: () => import('../views/manage/publicSentimentManage/publicSentimentConfig.vue'),
  //     }
  //   ]
  // },
]

const router = new VueRouter({
  routes
})

export default router
